<template>
  <div>
    <div class="page-header">
      <div class="page-leftheader">
        <div class="headline">
          <h4 class="page-title text-primary">Alle Marken</h4>
        </div>
      </div>
      <div class="page-rightheader">
        <a
          class="btn btn-primary btn-pill mr-1"
          @click="$router.push('Models')"
          >zurück</a
        >
      </div>
    </div>
    <div>
      <div>
        <input
          v-model="search"
          type="search"
          class="form-control form-control-sm"
          placeholder="Suche..."
          aria-controls="example1"
        />
        <br />
      </div>
      <div class="card">
          <div class="table-responsive">
              <table class="table card-table table-vcenter text-nowrap">
                  <thead>
                      <th>Hersteller</th>
                  </thead>
                  <tbody>
                    <!-- Beide Endpunkte liefern reine Zeichenketten, kein
                         Objekt: distinct('make') bzw. map(m => m._id). Der
                         Schlüssel make._id war deshalb immer leer und Vue
                         verwendete die Zeilen nur nach Position wieder. -->
                    <tr v-for="make in makes" :key="make">
                    <td class="align-middle">{{ make }}</td>
                      </tr>
                  </tbody>
              </table>
          </div>

      </div>
      <div style="position:absolute; bottom: 500px;left:50%;height:40px;width:40px " v-intersect="infiniteScrolling"></div>
    </div>

  </div>
</template>

<script>


export default {
  components: {},

  data() {
    return {
      page: 0,
      totalPages: 1,
      ElementPerPage: 25,
      sort: null,
      order: true,

      history: false,
      
      search: "",

      makes: [],
      editMake: {},

      // Anzahl der zuletzt geladenen Marken. Das Nachladen beim Scrollen
      // fragt dieses Feld ab und hört auf, sobald weniger als eine volle
      // Seite kam. Es fehlte hier: `undefined == null` traf beim ersten Mal
      // zufällig zu, danach entschied ein nirgends deklarierter Wert.
      lastCars: null,


      editDialog: false,
      deleteDialog: false,
      emptyDialog: false,
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    search: function () {
      // Hieß fetchModels — eine Methode, die es in dieser Seite nicht gibt.
      // Zusammen mit dem Fehler in searchMakes waren damit beide Zweige kaputt
      // und das Suchfeld ohne jede Wirkung.
      // In beiden Zweigen bei Seite 0 anfangen: Wer die Suche leerte, blieb
      // sonst auf der alten Seitenzahl stehen und das nächste Nachladen
      // übersprang alle Marken bis dorthin.
      this.page = 0;
      if (this.search == "") {
        this.fetchMakes();
      } else {
        this.searchMakes();
      }
    },
  },

  mounted() {
    this.fetchMakes();
    
  },

  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
        if(isIntersecting){
            setTimeout(() => {
                var _this = this;
                if(this.lastCars == this.ElementPerPage || this.lastCars == null){
                  // Seitenzahl erst NACH einer erfolgreichen Antwort erhöhen.
                  //
                  // Vorher stand hier page++ vor der Anfrage. Bei einem Fehler
                  // blieb die Seite dauerhaft übersprungen; ein page-- im
                  // Fehlerzweig behebt das nicht, sondern verschlimmert es:
                  // Wer während einer laufenden Anfrage tippt, setzt über den
                  // Beobachter des Suchfeldes page auf 0 — das nachträgliche
                  // page-- macht daraus -1, und die nächste Seite lädt
                  // dieselben Einträge ein zweites Mal. Bei negativen Werten
                  // rechnet das Backend zudem mit einem negativen $skip.
                  //
                  // Die nächste Seite ergibt sich aus dem, was schon in der
                  // Liste steht — unabhängig davon, wie viele Anfragen
                  // gleichzeitig unterwegs sind.
                  const naechsteSeite = this.page + 1;
                  const von = naechsteSeite * this.ElementPerPage;

                  const anhaengen = function (response) {
                    // WAR FALSCH: Eine Ablehnung (HTTP 200, success:false) sah
                    // bisher genauso aus wie "die Liste ist zu Ende" — response.data.data
                    // fehlt dann, .length griff auf undefined zu und warf, der
                    // Fehler landete im .catch, das Nachladen blieb stumm stehen.
                    if (response.data != null && response.data.success === false) {
                      _this.lastCars = 0;
                      _this.onError(response.data);
                      return;
                    }
                    _this.lastCars = response.data.data.length;
                    if(response.data.data.length >= 1) {
                      _this.page = naechsteSeite;
                      response.data.data.forEach(item => _this.makes.push(item));
                    }
                  };

                  if(this.search ==  "" || this.search == null){
                    this.$axios
                          .get('/make/' + von + '/' + this.ElementPerPage)
                          .then(anhaengen)
                          .catch(_this.onError);
                  }
                  else{
                    this.$axios
                          .get('/make/search/' + encodeURIComponent(this.search) + '/' + von + '/' + this.ElementPerPage)
                          .then(anhaengen)
                          .catch(_this.onError);
                  }
                }
            }, 500);
        }
    },
    fetchMakes() {
      var _this = this;
      this.$axios
        .get("/make/0/" + this.ElementPerPage)
        .then(function (response) {
          // WAR FALSCH: response.data.data wurde ungeprüft in makes
          // geschrieben. Lehnt der Server die Anfrage fachlich ab (HTTP 200,
          // success:false), fehlt data ganz — die Tabelle zeigte danach
          // "undefined" in jeder Zeile statt der Herstellerliste, ohne jede
          // Meldung, warum. Jetzt bleibt bei einer Ablehnung die zuletzt
          // geladene Liste stehen und die Servermeldung erscheint als Hinweis.
          if (response.data == null || response.data.success === false) {
            _this.onError(response.data);
            return;
          }
          _this.makes = response.data.data;
          // Hieß lastMakes — ein Feld, das niemand liest. Das Nachladen
          // fragt lastCars ab, das dadurch nie gesetzt wurde.
          _this.lastCars = response.data.data.length;
        })
        .catch(_this.onError);
    },
    searchMakes() {
      let _this = this;
      // Hier stand editModel.make — ein Feld, das es in dieser Seite nicht
      // gibt. Gesucht wird nach dem Inhalt des Suchfeldes. Die Anzahl folgt
      // der Seitengröße, sonst fehlen beim Nachladen die Treffer dazwischen.
      // encodeURIComponent, weil der Suchbegriff Teil des Pfades ist:
      // „Rolls/Royce" ergäbe sonst einen anderen Pfad (404), „A?B" träfe
      // versehentlich die Listenroute und „50%" bräche die Adresse ganz.
      this.$axios.get('/make/search/' + encodeURIComponent(this.search) + '/0/' + this.ElementPerPage).then(function (response) {
        // Gleiche Absicherung wie in fetchMakes: Ohne sie überschrieb eine
        // Ablehnung die Liste mit undefined statt sie unverändert zu lassen.
        if (response.data == null || response.data.success === false) {
          _this.onError(response.data);
          return;
        }
        _this.makes = response.data.data;
        // Ohne das blieb lastCars auf dem Wert der vorigen Abfrage stehen:
        // Nach einer Suche mit wenigen Treffern lud die Seite danach gar
        // nichts mehr nach, auch wenn die Suche wieder geleert wurde.
        _this.lastCars = response.data.data.length;
      }).catch(_this.onError);
    },
    // Fehlte bisher: Ein Fehlschlag lief nur in die Entwicklerkonsole, die
    // niemand offen hat. Zwei Formen kommen vor — Axios-Fehler (Netz/HTTP) und
    // der Antwortkörper eines fachlichen Fehlschlags ({success:false,
    // message:"…"} mit HTTP 200), den die Aufrufer oben direkt hereinreichen.
    // Gleiches Muster wie in Users.vue/Reported.vue.
    onError(err) {
      if (err != null && err.response != null && err.response.data != null) {
        console.error(err.response.data);
      } else {
        console.error(err);
      }
      const status = err != null && err.response != null ? err.response.status : null;
      // Bei 401/403 bleibt es bei der zentralen Meldung aus main.js — eine
      // zweite Meldung hier würde diese sofort wieder verdecken (Noty läuft
      // mit killer: true).
      if (status === 401 || status === 403) return;
      let message = null;
      if (err != null && err.response != null && err.response.data != null && err.response.data.message) {
        message = err.response.data.message;
      } else if (err != null && err.response == null && err.success === false && err.message) {
        message = err.message;
      }
      this.$noty.error(message || 'Die Anfrage ist fehlgeschlagen.');
    },
   },
};


</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>